import React, { useEffect, useState } from 'react';
import { Button, Tab, Tabs } from '@material-ui/core';
import { Add } from '@material-ui/icons';
import CustomUiBuilderTextField from '../../../../shared/form-controls/custom-ui-builder-text-field/Custom-UI-Builder-Text-Field';
import { ACCORDION_WO_ICON } from '../../../../constants/UiBuilderConst';
import TextField from '@mui/material/TextField';
import { InputAdornment } from '@mui/material';
import { handleRemoveClick } from '../../../../utils/UiBuilderUtils';

const AccordionWithoutIcon = (props) => {
  const { onItemChange, config, handleError, componentNdx } = props;
  const initialSlide = {
    titleH3: '',
    body: '',
  };
  const [slidesList, setSlidesList] = useState(
    config?.accordions && config?.accordions?.length ? config.accordions : [initialSlide],
  );
  const [activeTabIndex, setActveTabIndex] = useState(0);
  const [activeTabContent, setActveTabContent] = useState(
    config?.accordions && config?.accordions?.length ? config.accordions[0] : initialSlide,
  );
  const [error, setError] = useState(null);

  useEffect(() => {
    onItemChange({
      componentName: ACCORDION_WO_ICON,
      config: {
        accordions: slidesList,
      },
    });
  }, [slidesList]);

  useEffect(() => {
    if (handleError && handleError.length > 0) {
      const currError = handleError.find(
        (getError) => getError.pos === componentNdx && getError.id === ACCORDION_WO_ICON,
      );
      if (currError && currError.accordions.length > 0) {
        const sliderNdx = Math.min.apply(
          Math,
          currError.accordions.map((o) => o.pos),
        );
        setActveTabIndex(sliderNdx);
        setActveTabContent(slidesList[sliderNdx]);
      }
      setError(currError ?? null);
    }
  }, [handleError]);

  const onTabAdd = () => {
    if (slidesList.length < 8) {
      const tempList = [...slidesList];
      tempList.push(initialSlide);
      setActveTabContent(initialSlide);
      setSlidesList(tempList);
      setActveTabIndex(tempList.length - 1);
    }
  };

  const setErrorField = (field, val) => {
    if (field !== 'redirect') {
      const trimmed = typeof val === 'string' ? val?.trim() : val;
      return trimmed ? '' : 'required';
    } else {
      if (val?.type && val?.value) return '';
      return 'required';
    }
  };

  const handleTabData = (val, slideContent, field) => {
    const thisErr = setErrorField(field, val);
    const newAccordionsErr = slidesList?.map((_, idx) => {
      const prev = error?.accordions?.find((e) => e?.pos === idx) || { pos: idx };
      return idx === activeTabIndex ? { ...prev, [field]: thisErr } : prev;
    });
    const newConfigErr = { ...(error?.config || {}) };
    setError({ config: newConfigErr, accordions: newAccordionsErr });
    switch (field) {
      case 'titleH3':
        slideContent.titleH3 = val;
        break;
      case 'body':
        slideContent.body = val;
        break;
      default:
        break;
    }
    setSlidesList(
      slidesList?.map((slide, index) => {
        if (index === activeTabIndex) {
          return slideContent;
        } else {
          return slide;
        }
      }),
    );
  };

  const onTabChange = (e, value) => {
    setActveTabIndex(value);
    setActveTabContent(slidesList[value]);
  };

  const hasError = (key) => {
    const hasSliderError = error?.accordions?.find(
      (errorSlider) => errorSlider.pos === activeTabIndex && errorSlider[key] === 'required',
    );
    if (hasSliderError) return true;
    return false;
  };

  return (
    <div className='row my-2 mx-4'>
      <div className='col-md-10'>
        <div className='row mt-4 mb-3'>
          <div className='col-md-12 slide-tabs d-flex'>
            <Tabs
              value={activeTabIndex}
              variant='fullWidth'
              indicatorColor='primary'
              onChange={onTabChange}
              aria-label='tabs'
              textColor='primary'
              className='tabs'
            >
              {slidesList.map((tab, key) => (
                <Tab key={key} label={'Accordion ' + (key + 1)} />
              ))}
            </Tabs>
            <div className='ms-2'>
              <Button
                disabled={slidesList.length > 7}
                variant='outlined'
                size='large'
                color='secondary'
                onClick={(e) => onTabAdd(e)}
              >
                <Add />
              </Button>
            </div>
          </div>
          <div className='col-md-12 pe-5 mt-3'>
            <div className='col-md-12'>
              <TextField
                className='mt-2 col-md-12'
                variant='standard'
                label=''
                value={'Accordion ' + (activeTabIndex + 1)}
                InputProps={{
                  style: { color: '#828282' },
                  endAdornment: (
                    <InputAdornment position='end' className='pointer text-underlined'>
                      <span
                        onClick={(e) =>
                          handleRemoveClick(
                            e,
                            activeTabIndex,
                            slidesList,
                            setSlidesList,
                            setActveTabIndex,
                            setActveTabContent,
                          )
                        }
                      >
                        Remove
                      </span>
                    </InputAdornment>
                  ),
                }}
              />
              <CustomUiBuilderTextField
                label='H3 Title'
                required={true}
                className='col-md-12 mt-3'
                value={activeTabContent.titleH3}
                onChangeInput={(e) => handleTabData(e.target.value, activeTabContent, 'titleH3')}
                maxLength={100}
                isAdornment={true}
                endAdornment={true}
                error={hasError('titleH3')}
              />
              <CustomUiBuilderTextField
                label='Body2'
                required={true}
                className='col-md-12 mt-3'
                value={activeTabContent.body}
                onChangeInput={(e) => handleTabData(e.target.value, activeTabContent, 'body')}
                maxLength={9000}
                isAdornment={true}
                multiline={true}
                endAdornment={true}
                error={hasError('body')}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccordionWithoutIcon;
